import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appProductMenuFooterInflatorContainer]',
  standalone: false
})
export class ProductMenuFooterInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
